const FILTER_LOCATION_SELECTOR_TYPES = {
  CITY: "City",
  COUNTY: "County",
  ZIP: "Zip Code",
  COUNTRY: "Country",
  STATE: "State",
  DISTRICT: "Legislative District",
  COMMITTEE: "Committee District",
};

const ALLOW_ASYNC_SEARCH = [
    FILTER_LOCATION_SELECTOR_TYPES.CITY,
    FILTER_LOCATION_SELECTOR_TYPES.COUNTY,
    FILTER_LOCATION_SELECTOR_TYPES.ZIP,
    FILTER_LOCATION_SELECTOR_TYPES.COUNTRY
];

const LOCATION_TYPE_ROUTES = {
  [FILTER_LOCATION_SELECTOR_TYPES.CITY]: "city",
  [FILTER_LOCATION_SELECTOR_TYPES.COUNTY]: "county",
  [FILTER_LOCATION_SELECTOR_TYPES.ZIP]: "zipCode",
  [FILTER_LOCATION_SELECTOR_TYPES.COUNTRY]: "country"
};

const LOCATION_TYPE_PARAMS = {
  [FILTER_LOCATION_SELECTOR_TYPES.COMMITTEE]: {
    offset: 0,
    limit: 20000
  },
};

export { FILTER_LOCATION_SELECTOR_TYPES, LOCATION_TYPE_ROUTES, LOCATION_TYPE_PARAMS, ALLOW_ASYNC_SEARCH };
